import { useState } from "react";
import { useDispatch } from "react-redux";
import { setErrors } from "../../../store/alerts/alertsActions";
import { logInWithPassword } from "../../../store/auth/authActions";

export default function useLogin(onClose: () => void) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();

  const validateForm = () => {
    return email.length > 0 && password.length > 0;
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();
    if (!validateForm()) {
      dispatch(setErrors(["Podaj email i hasło"]));
    } else {
      dispatch(logInWithPassword({ email, password }));
      onClose();
    }
  };

  return {
    email,
    setEmail,
    password,
    setPassword,
    handleSubmit
  };
};
